module.exports = __webpack_public_path__ + "img/135-Schwarzgrau SFTN.jpg";